import React, { useContext, useState, useEffect, useRef } from 'react';
import loadable from '@loadable/component';
import { CartContext } from 'components/cart';
import useCampaign from 'hooks/useCampaign';
import classNames from 'lib/classNames';
import { FilterAtuGoals } from '../Utils';
const Scary = loadable(() => import('./scary'));
const Announcement = loadable(() => import('./announcement'));
const HeaderATU = loadable(() => import('./Header_ATU'));

const Header = (props) => {
    const {
        cart_settings: {
            header,
            theme: { background, primary },
            rtl,
            curved,
            scary = {},
            announcement = {}
        },
        slider: { slickGoTo, active_slide },
        scrollbars_ref,
        shopify_cart_items,
        campaigns,
        Utils,
        isPreview,
        close,
        productAddedToCart,
        discountCode
    } = useContext(CartContext);
    const loadingBarRef = useRef();
    const back = () => {
        slickGoTo(0);
        scrollbars_ref.scrollTop = 0;
    };
    const [add_to_unlock_product_id, add_to_unlock_campaign, isGlobal] = useCampaign(
        'add_to_unlock',
        null,
        true
    )(campaigns, shopify_cart_items);
    const { add_to_unlock, campaign_key } = add_to_unlock_campaign || {};
    const goals = add_to_unlock?.goals || [];
    const filterGoalsBasedOnDiscount = FilterAtuGoals(goals, !!discountCode);
    const CAN_RENDER_ADD_TO_UNLOCK =
        filterGoalsBasedOnDiscount.length &&
        add_to_unlock?.isActive &&
        (productAddedToCart({ id: add_to_unlock_product_id }) ||
            (isGlobal && shopify_cart_items.length));
    const bundlesDiscounts = Utils.getDiscount({
        campaigns,
        items: shopify_cart_items,
        getBundlesOnly: true
    });
    return (
        <div
            className={classNames({
                shadow: !CAN_RENDER_ADD_TO_UNLOCK && !scary.placement === 'top'
            })}
            ref={props.headerRef}
            // style={{
            // 	background: Utils.formatColor(background),
            // 	borderRadius: curved ? "16px 16px 0px 0px" : ""
            // }}
        >
            <div
                className={classNames('px-5 py-3 flex items-center relative')}
                style={{
                    background: Utils.formatColor(header.background),
                    color: Utils.formatColor(header.title.color),
                    borderRadius: curved ? '15px 15px 0px 0px' : ''
                }}
            >
                <div
                    className={classNames(
                        rtl ? 'pl-2' : 'pr-2',
                        active_slide !== 1 ? 'opacity-0' : 'cursor-pointer'
                    )}
                >
                    <svg
                        aria-hidden="true"
                        style={{ width: 15, height: 15 }}
                        focusable="false"
                        data-icon="chevron-left"
                        onClick={() => back()}
                        className={classNames('cursor-pointer')}
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={rtl ? '0 0 320 512' : '0 0 384 512'}
                    >
                        {!rtl && (
                            <path
                                fill="currentColor"
                                d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
                            ></path>
                        )}
                        {rtl && (
                            <path
                                fill="currentColor"
                                d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
                            ></path>
                        )}
                    </svg>
                </div>
                <span
                    className={classNames('flex-1 flex-grow text-center font-bold cart-header')}
                    style={{
                        fontSize: Utils.em(header.title.font_size),
                        fontWeight: header.title.font_weight
                    }}
                >
                    {header.title.text}
                </span>
                <div className={classNames(rtl ? 'pr-2' : 'pl-2', 'cursor-pointer')}>
                    <svg
                        aria-hidden="true"
                        style={{ width: 15, height: 15 }}
                        focusable="false"
                        data-icon="times"
                        onClick={() => (close ? close() : null)}
                        className={classNames('cursor-pointer')}
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                    >
                        <path
                            fill="currentColor"
                            d="M323.1 441l53.9-53.9c9.4-9.4 9.4-24.5 0-33.9L279.8 256l97.2-97.2c9.4-9.4 9.4-24.5 0-33.9L323.1 71c-9.4-9.4-24.5-9.4-33.9 0L192 168.2 94.8 71c-9.4-9.4-24.5-9.4-33.9 0L7 124.9c-9.4 9.4-9.4 24.5 0 33.9l97.2 97.2L7 353.2c-9.4 9.4-9.4 24.5 0 33.9L60.9 441c9.4 9.4 24.5 9.4 33.9 0l97.2-97.2 97.2 97.2c9.3 9.3 24.5 9.3 33.9 0z"
                        ></path>
                    </svg>
                </div>
            </div>
            {!!shopify_cart_items.length &&
                announcement?.isActive &&
                announcement.position === 'bellow_header' && (
                    <Announcement announcement={announcement} />
                )}
            {!!shopify_cart_items.length && scary.isActive && scary.placement === 'top' && (
                <Scary scary={scary} />
            )}
            {!!CAN_RENDER_ADD_TO_UNLOCK && (
                <HeaderATU
                    campaign_id={campaign_key && campaign_key[1]}
                    add_to_unlock={add_to_unlock}
                    bundlesDiscounts={bundlesDiscounts}
                />
            )}
        </div>
    );
};

export default Header;
